import React from "react";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, Col } from "react-bootstrap";
import { SeasonsListTable } from "../allTables/allTable";
import { useEffect } from "react";
import { useState } from "react";
import * as yup from "yup";
import {
  AddSeason,
  DeleteStandingModule,
} from "../modals/allModal";
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import SeasonsService from "../../services/season.service";
import { useLocation } from "react-router-dom";

const schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  year: yup.string().required("Year is Required"),
});

export function SeasonsList() {
  const location = useLocation();
  const { search } = location;
  const selectedType = search.split("=")[1];
  const [data, setData] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [deleteModal, setDeleteModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loader, setLoader] = useState(false);
  const [totalRows, setTotalRows] = useState("");
  const handleDialogClose = () => setModalShow(false);
  const handleDialogOpen = () => setModalShow(true);
  const [changes, setChanges] = useState("");
  const handleDeleteClose = () => setDeleteModal(false);

  const getAllSeasonsList = async () => {
    setIsLoading(true);
    try {
      const response = await SeasonsService.getAllSeasonsList(
        pageNumber,
        dataPerPage,
        selectedType.toUpperCase()
      );
      setData(response.data.data);
      setTotalRows(response.data.total);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    await getAllSeasonsList();
    setIsLoading(false);
  };

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllSeasonsList();
  }, [pageNumber, dataPerPage, selectedType]);

  const handleOpen = async () => {
    setModalShow(true);
  };

  const initialValue = {
    name: "",
    year: "",
  };

  const submit = async (values, action) => {
    try {
      setLoader(true);
      const data = { 
        ...values,
        type: selectedType.toUpperCase(),
      };
      await SeasonsService.createSeasonsList(data);
      setLoader(false);
      setModalShow(false);
      getAllSeasonsList();
      action.resetForm();
      formik.resetForm();
    } catch (error) {
      enqueueSnackbar(
        error.response.data.message ===
          "Duplicate Seasons data. Upload not allowed."
          ? "Same Data Not Allowed"
          : "Something went Wrong",
        {
          variant: "error",
        }
      );
      setLoader(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const handleDelete = () => {
    setDeleteModal(true);
  };

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Seasons
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fa fa-solid fa-list-ul icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalRows}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col
          sm={12}
          md={6}
          lg={6}
          xl={6}
          className="d-flex ms-auto mt-auto "
          style={{ justifyContent: "end" }}>
          {/* <div className="me-3">
            <InputGroup className="d-flex justify-content-end">
              <Searchable
                className="form-control select2 ml-0"
                value={showFilterValue}
                placeholder="All"
                notFoundText="No result found"
                noInput
                selectedVal={showFilterValue}
                options={[]}
                onSelect={(e) => handleStatusFilter(e)}
                listMaxHeight={150}
              />
            </InputGroup>
          </div> */}
          <div
            className="custom-card text-end  pointer "
            style={{ marginRight: "18px" }}>
            <Button
              className="text-white"
              onClick={() => handleOpen("")}
              style={{ marginBottom: "5px", marginLeft: "15px" }}>
              <i className="fas fa-plus"></i> &nbsp; Add Season
            </Button>

            {modalShow && (
              <AddSeason
                show={handleDialogOpen}
                onHide={handleDialogClose}
                loader={loader}
                formik={formik}
                handleFieldChange={handleFieldChange}
              />
            )}
            {deleteModal && (
              <DeleteStandingModule
                show={deleteModal}
                onHide={handleDeleteClose}
                formik={formik}
                getAllStanding={getAllSeasonsList}
              />
            )}
          </div>
        </Col>
      </div>

      <SeasonsListTable
        data={data}
        totalRows={totalRows}
        handlePageChange={handlePageChange}
        dataPerPage={dataPerPage}
        isLoading={isLoading}
        setDataPerPage={setDataPerPage}
        getAllSeasons={getAllSeasonsList}
      />
    </>
  );
}
